/**
 * @Description: "设备管理接口请求"
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors:   YOYO [792611446@qq.com]
 * @Date:   2020-11-16 17:18:31
 * @LastEditTime: 2020-11-23 11:38:57
 */

import { post, get } from '@/utils/request'

/**
 * @description   获取列表
 * @param {*} params
 */
export async function getList (params) {
  return get('/rest/getEquipInfo', params)
}
/**
 * @description   字典
 * @param {*} params
 */
export async function getDic (type) {
  return get(`/rest/${type}`)
}
/**
 * @description   新增数据
 * @param {*} params
 */
export async function saveData (params) {
  return post('/rest/saveOrUpdateEquip', params)
}

export const editSaveData = params => {
  return post('/rest/updateEquip', params)
}
/**
 * @description   操作记录
 * @param {*} params
 */
export async function getEquipOperaterInfos (params) {
  return get('/rest/getEquipOperaterInfos', params)
}

/**
 * @description:  删除数据
 * @param {*}
 * @return {*}
 */
export const deleteData = params => {
  return post('/rest/delete', params)
}
